/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinksdownloadpng3Inputs */

const en_downloadlinksdownloadpng3 = /** @type {(inputs: Downloadlinksdownloadpng3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download PNG`)
};

const de_downloadlinksdownloadpng3 = /** @type {(inputs: Downloadlinksdownloadpng3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG herunterladen`)
};

/**
* | output |
* | --- |
* | "Download PNG" |
*
* @param {Downloadlinksdownloadpng3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksdownloadpng3 = /** @type {((inputs?: Downloadlinksdownloadpng3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksdownloadpng3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksdownloadpng3(inputs)
	return de_downloadlinksdownloadpng3(inputs)
});
export { downloadlinksdownloadpng3 as "downloadLinksDownloadPng" }